import { EtaLocation } from '@/feature/eta'
import { MapMarker } from '@/feature/map'
import { ACTIVE_MARKER } from '@/feature/observatory'

import { ICON_MAP } from '../../constants'
import { color } from '../../utils/Eta.utils'
import styles from './Eta.module.css'

export const EtaMapMarker = ({ etaLocation }: { etaLocation: EtaLocation }) => {
  const Icon = ICON_MAP[etaLocation.type]

  return (
    <MapMarker
      animate={false}
      position={{ lat: etaLocation.latitude, lng: etaLocation.longitude }}
      className={styles.baseMarker}
      zIndex={ACTIVE_MARKER}
      clusterer={false}
    >
      <div className={styles.marker}>
        <span className={styles.centeredAssetIcon}>
          <Icon
            rotate={etaLocation.heading ?? 0}
            color={color(etaLocation)}
            highRiskArea={etaLocation.highRiskArea ?? false}
          />
        </span>
      </div>
    </MapMarker>
  )
}
